import { z } from 'zod';
import { HitpointsEvent } from '../event.js';
import { ShoppingListItem } from './shoppingList.types.js';
const ShoppingListItemsAdded = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemsAdded'),
    items: ShoppingListItem.array(),
    index: z.number().min(0).optional(),
});
const ShoppingListItemUpdated = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemUpdated'),
    item: ShoppingListItem,
});
const ShoppingListItemsRemoved = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemsRemoved'),
    itemIds: z.string().uuid().array(),
});
const ShoppingListItemsChecked = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemsChecked'),
    itemIds: z.string().uuid().array(),
});
const ShoppingListItemsUnchecked = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemsUnchecked'),
    itemIds: z.string().uuid().array(),
});
const ShoppingListItemMoved = HitpointsEvent.extend({
    type: z.literal('ShoppingListItemMoved'),
    itemId: z.string().uuid(),
    index: z.number().min(0),
});
export const shoppingListTypeMap = {
    ShoppingListItemsAdded,
    ShoppingListItemUpdated,
    ShoppingListItemsRemoved,
    ShoppingListItemsChecked,
    ShoppingListItemsUnchecked,
    ShoppingListItemMoved,
};
const shoppingListEventTypes = Object.keys(shoppingListTypeMap);
export function isShoppingListEvent(event) {
    return shoppingListEventTypes.includes(event.type);
}
//# sourceMappingURL=shoppingList.events.js.map